const LOCAL_STORAGE_PREFIX_KEY = '@flixmedia-cortesias-webapp';

type Module = 'session' | 'distribution';
type StoreSession = {
    module: 'session',
    key: 'user'
};
type StoreDistribution = {
    module: 'distribution',
    key: 'all' | 'step' | 'exhibitor' | 'voucher_type' | 'template' | 'recipients' | 'dueDate' | 'customError'
};
type Store = {
    module: Module;
} & StoreSession | StoreDistribution;

type AddStore = Store & {
    data: any;
}

type GetStore = Store & {
    defaultValue: null | never[] | number | string;
}

const getKey = ({ module, key }: Store) => `${LOCAL_STORAGE_PREFIX_KEY}/${module}:${key}`;

const addToLocalStorage = (stores: AddStore | AddStore[]) => {
    (Array.isArray(stores) ? stores : [stores]).forEach(({ data, ...store }) => {
        localStorage.setItem(getKey(store), JSON.stringify(data));
    });
};

const clearFromLocalStorage = (store: Store): void =>
    localStorage.removeItem(getKey(store));

const clearByModuleFromLocalStorage = (module: Module): void =>
    Object.keys(localStorage).filter(key => key.includes(module)).forEach(key => localStorage.removeItem(key));

const getFromLocalStorage = ({ defaultValue, ...store }: GetStore): any => {
    const data = localStorage.getItem(getKey(store));
    return data ? JSON.parse(data) : defaultValue;
};

const getAndClearFromLocalStorage = ({ defaultValue, ...store }: GetStore): any => {
    const data = localStorage.getItem(getKey(store));
    setTimeout(() => clearFromLocalStorage(store), 5000);
    return data ? JSON.parse(data) : defaultValue;
};

export { addToLocalStorage, clearFromLocalStorage, clearByModuleFromLocalStorage, getFromLocalStorage, getAndClearFromLocalStorage };